import { CONTACT_EMAIL, patientSignInUrl } from "../config";
import { LogoMark, LogoWord } from "./Logo";

/** DrStack footer — brand blurb, link columns, copyright. Column links are same-page anchors, per
 * the original site; the "Sign in" portal link is retained from the old marketing app. */
export function Footer() {
  return (
    <footer>
      <div className="wrap">
        <div className="foot">
          <div className="foot-brand">
            <a className="logo" href="#top">
              <LogoMark size={30} gradientId="lgf" />
              <LogoWord />
            </a>
            <p>The turnkey, AI-powered platform for launching telehealth services under your brand.</p>
          </div>
          <div className="foot-col">
            <h4>Platform</h4>
            <a href="#platform">Patient Experience</a>
            <a href="#platform">Video Visits</a>
            <a href="#platform">e-Prescribing</a>
            <a href="#platform">Billing</a>
            <a href="#ai">AI Copilot</a>
          </div>
          <div className="foot-col">
            <h4>Company</h4>
            <a href="#top">About</a>
            <a href="#trust">Security</a>
            <a href="#contact">Contact</a>
            <a href={patientSignInUrl()}>Sign in</a>
          </div>
          <div className="foot-col">
            <h4>Resources</h4>
            <a href="#how">How It Works</a>
            <a href="#contact">Book a Demo</a>
            <a href="#trust">Compliance</a>
          </div>
        </div>
        <div className="copy">
          <span>© 2026 DrStack, Inc. All rights reserved.</span>
          <span>
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
